import { Skeleton } from '@repo/ui'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { AdminPageHeader } from '@/features/admin/layout/admin-page-header'
import { OrganizationForm } from '@/features/admin/organizations/components/organization-form'
import { useAdminOrganization } from '@/features/admin/organizations/hooks/use-admin-organization'
import { useUpdateAdminOrganization } from '@/features/admin/organizations/hooks/use-update-admin-organization'
import { router } from '@/router'

export const Route = createFileRoute('/admin/organizations/$orgId/edit')({
  component: AdminOrganizationEditPage,
})

function AdminOrganizationEditPage() {
  const { t } = useTranslation('admin')
  const { orgId } = Route.useParams()
  const id = Number(orgId)
  const { data, isPending } = useAdminOrganization(id)
  const { mutate, isPending: isSubmitting } = useUpdateAdminOrganization(id)

  return (
    <div className="space-y-4">
      <AdminPageHeader
        title={t('organizations.edit.title')}
        subtitle={data?.name}
      />
      <div className="mx-auto max-w-3xl">
        {isPending || !data ? (
          <Skeleton className="h-96 w-full rounded-md" />
        ) : (
          <OrganizationForm
            defaultValues={{
              name: data.name,
              plan: data.plan ?? undefined,
              timezone: data.timezone,
              status: data.status,
              contactEmail: data.contactEmail ?? '',
              contactPhone: data.contactPhone ?? '',
              addressLine: data.addressLine ?? '',
              city: data.city ?? '',
              postalCode: data.postalCode ?? '',
              countryCode: data.countryCode ?? '',
              taxId: data.taxId ?? '',
              registrationNumber: data.registrationNumber ?? '',
              website: data.website ?? '',
              tachosyncCompanyId: data.tachosyncCompanyId ?? '',
              tachosyncCompanyName: data.tachosyncCompanyName ?? '',
            }}
            organizationId={id}
            hasTachoSyncKey={data.hasTachoSyncKey ?? false}
            isSubmitting={isSubmitting}
            onSubmit={(values) => mutate(values)}
            onCancel={() => router.navigate({ to: '/admin/organizations' })}
            submitLabel={t('organizations.edit.submit')}
          />
        )}
      </div>
    </div>
  )
}
